<bp-hl-area-container name="Bestand & Bemerkungen">
	<div class="touch-form">
		<bp-bestand-converter [data]="data"></bp-bestand-converter>
		<!-- Beschriftung ueber dem Feld wie bei „Bestand-Text" darueber, keine graue
		     Spalte davor (Nutzer-Entscheidung 02.10.2026). -->
		<div class="form-row">
			<div class="form-input-cell full-width">
				<wd-multiline-text-input name="Bemerkungen" label="Bemerkungen" [(model)]="data.header.bemerkungen"></wd-multiline-text-input>
			</div>
		</div>
	</div>
</bp-hl-area-container>
